import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';
import OurVisionModel from './our-vision.model.js';

class OurVisionService {
	getPageData(lang) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/OurVision?lang=${lang}`,
			)
			.then(res => new OurVisionModel(res.data))
			.catch(logError);
	}
}
export default new OurVisionService();
